import * as React from 'react'

const NoPicture = require('./default.png')

import { ImageDiv } from './Styles'
import { BACKEND_URL } from '../../constants'

type Props = {
  imageUrl?: string | null
  onClick?: () => void
}

export default class ThumbImage extends React.Component<Props> {
  render() {
    const { imageUrl, onClick = () => undefined } = this.props

    const url = imageUrl ? `${BACKEND_URL}/thumbnails/${imageUrl}` : null
    return (
      <ImageDiv onClick={onClick}>
        <img
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            position: 'relative',
            transform: 'translate(-50%, -50%)',
            left: '50%',
            top: '50%',
            objectFit: 'cover'
          }}
          src={url || NoPicture}
          alt=""
        />
      </ImageDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/ThumbImage.tsx